import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'imperioice_cookie_consent';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (accepted) => {
    localStorage.setItem(CONSENT_KEY, accepted ? 'accepted' : 'declined');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 200, damping: 25 }}
          className="fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-[60]"
          data-testid="cookie-banner"
        >
          <div className="bg-gradient-to-br from-[#0f1f3a] to-[#0a1628] backdrop-blur-xl rounded-2xl shadow-2xl border border-[#7dd3fc]/30 p-6">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-[#7dd3fc]/10 rounded-xl flex items-center justify-center">
                <Cookie className="text-[#7dd3fc]" size={24} />
              </div>
              <div className="flex-1">
                <h3 className="text-white font-bold text-lg mb-2">Aviso de Cookies</h3>
                <p className="text-white/60 text-sm leading-relaxed mb-4">
                  Utilizamos cookies para melhorar sua experiência de navegação. Ao continuar, você concorda com nossa{' '}
                  <Link to="/privacidade" className="text-[#7dd3fc] hover:underline">
                    Política de Privacidade
                  </Link>.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={() => handleConsent(true)}
                    className="flex-1 py-2.5 px-4 bg-gradient-to-r from-[#7dd3fc] to-[#bae6fd] text-[#0a1628] font-bold text-sm rounded-lg hover:shadow-lg hover:shadow-[#7dd3fc]/30 transition-all duration-300"
                    data-testid="cookie-accept-btn"
                  >
                    Aceitar
                  </button>
                  <button
                    onClick={() => handleConsent(false)}
                    className="flex-1 py-2.5 px-4 bg-white/5 text-white/70 font-medium text-sm rounded-lg border border-white/10 hover:bg-white/10 transition-all duration-300"
                    data-testid="cookie-decline-btn"
                  >
                    Recusar
                  </button>
                </div>
              </div>
              <button
                onClick={() => handleConsent(false)}
                className="flex-shrink-0 text-white/40 hover:text-white transition-colors"
                data-testid="cookie-close-btn"
                aria-label="Fechar"
              >
                <X size={20} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
